import { render, staticRenderFns } from "./AppCookiePolicyBanner.vue?vue&type=template&id=74428fb8&"
import script from "./AppCookiePolicyBanner.vue?vue&type=script&lang=js&"
export * from "./AppCookiePolicyBanner.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiePolicyBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports